import { useHandleOfflineEncryptionKeyToCurrentTeam } from './hooks/useHandleOfflineEncryptionKeyToCurrentTeam';
import { useHandleOfflineEncryptionKeysToOtherTeams } from './hooks/useHandleOfflineEncryptionKeysToOtherTeams';

export const useHandleOfflineEncryptionKeys = ({
  teamId,
}: UseHandleOfflineEncryptionKeysParams) => {
  useHandleOfflineEncryptionKeysToOtherTeams({ currentTeamId: teamId });
  useHandleOfflineEncryptionKeyToCurrentTeam({ currentTeamId: teamId });
};

interface UseHandleOfflineEncryptionKeysParams {
  teamId?: string;
}
